import axios from 'axios';
import { API_ROOT, HOME_ROOT, PAGES_ROOT, WORKFLOW_ROOT } from 'config/api';
import { NON_WORKFLOW_PAGES } from 'config/workflow';

const pageActions = {
  ACCEPT_ADDRESS: 'PAGE_ACCEPT_ADDRESS',
  ACCEPT_ADDRESS_FAILED: 'PAGE_ACCEPT_ADDRESS_FAILED',
  ACCEPT_ADDRESS_SUCCESS: 'PAGE_ACCEPT_ADDRESS_SUCCESS',
  ADD_BENEFICIARY: 'GROUP_ADD_BENEFICIARY',
  ADD_SIGNER_STATUS: 'GROUP_ADD_SIGNER_STATUS',
  ADD_SIGNER_STATUS_BACK: 'GROUP_ADD_SIGNER_STATUS_BACK',
  BACK: 'PAGE_BACK',
  BACK_SUCCESS: 'PAGE_BACK_SUCCESS',
  CONTINUE_JOINT: 'PAGE_CONTINUE_JOINT',
  CONTINUE_JOINT_SUCCESS: 'PAGE_CONTINUE_JOINT_SUCCESS',
  CONTINUE_USER: 'GROUP_CONTINUE_USER',
  CONTINUE_USER_SUCCESS: 'GROUP_CONTINUE_USER_SUCCESS',
  DOCUMENT_UPLOAD_NEXT: 'PAGE_DOCUMENT_UPLOAD_NEXT',
  DOCUMENT_UPLOAD_NEXT_SUCCESS: 'PAGE_DOCUMENT_UPLOAD_NEXT_SUCCESS',
  GET_CURRENT: 'PAGE_GET_CURRENT',
  GO: 'PAGE_GO',
  GO_FAILED: 'PAGE_GO_FAILED',
  GO_NON_WORKFLOW: 'PAGE_GO_NON_WORKFLOW',
  GO_SUCCESS: 'PAGE_GO_SUCCESS',
  INVITE_JOINT: 'PAGE_INVITE_JOINT',
  LOGOUT: 'PAGE_LOGOUT',
  MOBILE_VALIDATION_RESEND: 'PAGE_MOBILE_VALIDATION_RESEND',
  MOBILE_VALIDATION_RESEND_FAILED: 'PAGE_MOBILE_VALIDATION_RESEND_FAILED',
  MOBILE_VALIDATION_RESEND_SUCCESS: 'PAGE_MOBILE_VALIDATION_RESEND_SUCCESS',
  MOBILE_VALIDATION_SUBMIT: 'PAGE_MOBILE_VALIDATION_SUBMIT',
  MOBILE_VALIDATION_SUBMIT_FAILED: 'PAGE_MOBILE_VALIDATION_SUBMIT_FAILED',
  MOBILE_VALIDATION_SUBMIT_SUCCESS: 'PAGE_MOBILE_VALIDATION_SUBMIT_SUCCESS',
  MOBILE_VALIDATION_SUCCESS: 'PAGE_MOBILE_VALIDATION_SUCCESS',
  NEXT: 'PAGE_NEXT',
  NEXT_FAILED: 'PAGE_NEXT_FAILED',
  NEXT_SUCCESS: 'PAGE_NEXT_SUCCESS',
  REMOVE_BENEFICIARY: 'GROUP_REMOVE_BENEFICIARY',
  REMOVE_PRODUCT: 'FUNDING_REMOVE_PRODUCT',
  REMOVE_SIGNER: 'GROUP_REMOVE_SIGNER',
  RESEND_EMAIL: 'GROUP_RESEND_EMAIL',
  RESEND_VERIFICATION_CODE: 'PAGE_RESEND_VERIFICATION_CODE',
  RESEND_VERIFICATION_CODE_FAILED: 'PAGE_RESEND_VERIFICATION_CODE_FAILED',
  RESEND_VERIFICATION_CODE_SUCCESS: 'PAGE_RESEND_VERIFICATION_CODE_SUCCESS',
  SAVE: 'PAGE_SAVE',
  SAVE_SIGNATURE: 'PAGE_SAVE_SIGNATURE',
  SAVE_SIGNATURE_FAILED: 'PAGE_SAVE_SIGNATURE_FAILED',
  SAVE_SIGNATURE_SUCCESS: 'PAGE_SAVE_SIGNATURE_SUCCESS',
  SAVE_SIGNERS: 'GROUP_SAVE_SIGNERS',
  START: 'PAGE_START',
  START_FAILED: 'PAGE_START_FAILED',
  START_SUCCESS: 'PAGE_START_SUCCESS',
  STATUS: 'PAGE_STATUS',
  STATUS_SUCCESS: 'PAGE_STATUS_SUCCESS',
  UPDATE_PAGE_DATA: 'UPDATE_PAGE_DATA',
  VERIFY_FUNDING: 'PAGE_VERIFY_FUNDING',
  VERIFY_FUNDING_FAILED: 'PAGE_VERIFY_FUNDING_FAILED',
  VERIFY_FUNDING_SUCCESS: 'PAGE_VERIFY_FUNDING_SUCCESS',

  acceptAddress: (accept) => ({
    payload: {
      request: (page, addressType) => () =>
        axios.post(`${PAGES_ROOT}/${page.name}/actions/acceptAddress`, {
          addressType,
          normalizedAddress: accept,
        }),
    },
    type: pageActions.ACCEPT_ADDRESS,
  }),
  addBeneficiary: () => ({
    payload: {
      request: (data, pageName) => () =>
        axios.post(`${PAGES_ROOT}/${pageName}/groups/BENEFICIARIES/actions/add`, data),
    },
    type: pageActions.ADD_BENEFICIARY,
  }),

  addSignerStatus: () => ({
    payload: {
      request: (data, pageName) => () =>
        axios.post(`${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/add`, data),
    },
    type: pageActions.ADD_SIGNER_STATUS,
  }),

  addSignerStatusBack: () => ({
    payload: {
      request: (data, pageName) => () =>
        axios.get(`${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/back`),
    },
    type: pageActions.ADD_SIGNER_STATUS_BACK,
  }),

  back: () => ({
    payload: {
      request: (pageName) => () => axios.post(`${PAGES_ROOT}/${pageName}/actions/back`, {}),
    },
    type: pageActions.BACK,
  }),

  backSuccess: (data) => ({
    payload: { data },
    type: pageActions.BACK_SUCCESS,
  }),
  continueJoint: () => ({
    payload: {
      request: () => axios.post(`${PAGES_ROOT}/done/actions/continueAsJoint`, {}),
    },
    type: pageActions.CONTINUE_JOINT,
  }),
  continueJointSuccess: (data) => ({
    payload: { data },
    type: pageActions.CONTINUE_JOINT_SUCCESS,
  }),

  continueUser: (index) => ({
    payload: {
      request: (_data, pageName) => () =>
        axios.post(
          `${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/continueAsSigner/${index}`,
          {},
        ),
    },
    type: pageActions.CONTINUE_USER,
  }),
  continueUserSuccess: (data) => ({
    payload: { data },
    type: pageActions.CONTINUE_USER_SUCCESS,
  }),
  documentUploadNext: (url) => ({
    payload: {
      request: () => axios.post(url, {}),
    },
    type: pageActions.DOCUMENT_UPLOAD_NEXT,
  }),

  // LIST GROUP ACTIONS! We can probably move these to a different file

  documentUploadSuccess: () => ({
    type: pageActions.DOCUMENT_UPLOAD_NEXT_SUCCESS,
  }),

  getCurrent: () => ({ type: pageActions.GET_CURRENT }),

  getRequest: (pageName) => () => {
    const path = !NON_WORKFLOW_PAGES.includes(pageName)
      ? `${PAGES_ROOT}/${pageName}`
      : `${WORKFLOW_ROOT}/${pageName}`;

    return axios.get(path);
  },

  goToNonWorkflowPage: (data) => ({
    payload: { data },
    type: pageActions.GO_NON_WORKFLOW,
  }),

  goToPageError: (data, status) => ({
    payload: { data, status },
    type: pageActions.GO_FAILED,
  }),

  goToPageSuccess: (data, changeGroup = true, nextGroup = false) => ({
    payload: { changeGroup, data, nextGroup },
    type: pageActions.GO_SUCCESS,
  }),
  inviteJoint: () => ({
    payload: {
      request: () => axios.post(`${PAGES_ROOT}/done/actions/inviteJoint`, {}),
    },
    type: pageActions.INVITE_JOINT,
  }),

  logout: (redirectUrl) => ({
    payload: {
      redirectUrl,
      request: () => axios.post(`${API_ROOT}/auth/logout`, {}),
    },
    type: pageActions.LOGOUT,
  }),
  mobileValidationFailed: (errorMsg, disableResend = false) => ({
    payload: { disableResend, errorMsg },
    type: pageActions.MOBILE_VALIDATION_SUBMIT_FAILED,
  }),
  mobileValidationResend: () => ({
    payload: {
      request: (endpoint) => () => axios.post(endpoint, {}),
    },
    type: pageActions.MOBILE_VALIDATION_RESEND,
  }),

  mobileValidationSubmit: (verificationCode) => ({
    payload: {
      request: (endpoint, payload) => () => axios.post(endpoint, payload),
      verificationCode,
    },
    type: pageActions.MOBILE_VALIDATION_SUBMIT,
  }),

  mobileValidationSuccess: (successMsg) => ({
    payload: { successMsg },
    type: pageActions.MOBILE_VALIDATION_SUCCESS,
  }),

  next: ({ isStatus = false } = {}) => ({
    payload: {
      isStatus,
      request: (path, data) => () => axios.post(path, data),
    },
    type: pageActions.NEXT,
  }),

  nextFailed: (data, fields) => ({
    payload: { data, fields },
    type: pageActions.NEXT_FAILED,
  }),

  nextSuccess: (data) => ({
    payload: { data },
    type: pageActions.NEXT_SUCCESS,
  }),

  removeBeneficiary: (index) => ({
    payload: {
      request: (_data, pageName) => () =>
        axios.delete(`${PAGES_ROOT}/${pageName}/groups/BENEFICIARIES/actions/delete/${index}`),
    },
    type: pageActions.REMOVE_BENEFICIARY,
  }),
  removeProduct: (appId) => ({
    payload: {
      appId,
      request: (_data, pageName) => () => axios.get(`${PAGES_ROOT}/${pageName}/cancel/${appId}`),
    },
    type: pageActions.REMOVE_PRODUCT,
  }),
  removeSigner: (index) => ({
    payload: {
      request: (_data, pageName) => () =>
        axios.delete(`${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/delete/${index}`),
    },
    type: pageActions.REMOVE_SIGNER,
  }),

  resendEmail: (index) => ({
    payload: {
      request: (_data, pageName) => () =>
        axios.post(
          `${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/resendEmail/${index}`,
          {},
        ),
    },
    type: pageActions.CONTINUE_USER,
  }),
  resendVerificationCode: () => ({
    payload: {
      request: (page) => () =>
        axios.post(`${PAGES_ROOT}/${page.name}/actions/resendVerificationCode`, {
          // TODO: Finish implementation of this feature (waiting on API)
        }),
    },
    type: pageActions.RESEND_VERIFICATION_CODE,
  }),
  save: () => ({
    payload: {
      request: (pageName, data) => () => axios.post(`${PAGES_ROOT}/${pageName}/actions/save`, data),
    },
    type: pageActions.SAVE,
  }),
  saveSignature: (id, data) => ({
    payload: {
      id,
      request: () => axios.post(`${PAGES_ROOT}/esign/agreements/${id}`, data),
    },
    type: pageActions.SAVE_SIGNATURE,
  }),
  saveSignatureError: (errorMsg) => ({
    payload: { errorMsg },
    type: pageActions.SAVE_SIGNATURE_FAILED,
  }),
  saveSignatureSuccess: (id) => ({ payload: { id }, type: pageActions.SAVE_SIGNATURE_SUCCESS }),

  saveSigners: () => ({
    payload: {
      request: (data, pageName) => () =>
        axios.post(`${PAGES_ROOT}/${pageName}/groups/BUSINESS_USERS/actions/saveSigners`, data),
    },
    type: pageActions.SAVE_SIGNERS,
  }),
  start: () => ({
    payload: {
      request: (page) => () => axios.post(`${PAGES_ROOT}/${page.name}/actions/start`, {}),
    },
    type: pageActions.START,
  }),

  /** VERIFY FUNDING AMOUNT ON THE HOME PAGE */
  startFailed: (data) => ({
    payload: { data },
    type: pageActions.START_FAILED,
  }),
  startSuccess: (page) => ({
    payload: page,
    type: pageActions.START_SUCCESS,
  }),
  status: (actionName, kbaSubmit = false) => ({
    payload: {
      kbaSubmit,
      request: (pageName) => () => axios.get(`${PAGES_ROOT}/${actionName || pageName}/status`),
    },
    type: pageActions.STATUS,
  }),
  updatePageData: (data) => ({
    payload: { data },
    type: pageActions.UPDATE_PAGE_DATA,
  }),
  verifyFunding: () => ({
    payload: {
      request: (data, appRequestId, fundingVerificationId) => () =>
        axios.post(`${HOME_ROOT}/${appRequestId}/fundingverify/${fundingVerificationId}`, data),
    },
    type: pageActions.VERIFY_FUNDING,
  }),
  verifyFundingFailed: (data) => ({
    payload: { data },
    type: pageActions.VERIFY_FUNDING_FAILED,
  }),
  verifyFundingSuccess: () => ({
    type: pageActions.VERIFY_FUNDING_SUCCESS,
  }),
};

export default pageActions;
